// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { screenMdMin, spacer4, spacer8, spacer16, Type, IconArrowRight } from '@spotify-internal/encore-web';
import { ContentfulImage } from '../../Contentful/ContentfulImage';
import { ButtonTertiaryAsLink, DELAYS, fadeInAnimation, ImageAspectBox1x2, withAnimationContext } from '../../ui';
import { fixHref } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Segment = styled.div.withConfig({
  displayName: "TwoUpSegment__Segment",
  componentId: "auxfm5-0"
})(["display:flex;flex-direction:row;justify-content:space-between;@media (max-width:", "){flex-direction:column;}"], screenMdMin);
var Left = styled.div.withConfig({
  displayName: "TwoUpSegment__Left",
  componentId: "auxfm5-1"
})(["width:50%;display:flex;flex-direction:column;@media (max-width:", "){width:100%;text-align:left;}"], screenMdMin);
var RightContainer = styled.div.withConfig({
  displayName: "TwoUpSegment__RightContainer",
  componentId: "auxfm5-2"
})(["width:40%;@media (max-width:", "){width:100%;display:flex;justify-content:center;img{padding-bottom:", ";}}"], screenMdMin, spacer16);
var Right = styled(ImageAspectBox1x2).withConfig({
  displayName: "TwoUpSegment__Right",
  componentId: "auxfm5-3"
})(["width:100%;padding:0px ", ";@media (max-width:", "){width:50%;}"], spacer16, screenMdMin);
var Headline = withAnimationContext(styled(Type.h1).attrs({
  paddingBottom: '0.75em',
  variant: 'alto',
  weight: 'bold'
}).withConfig({
  displayName: "TwoUpSegment__Headline",
  componentId: "auxfm5-4"
})(["", ";padding-bottom:", ";@media (max-width:", "){padding-top:", ";}"], fadeInAnimation(DELAYS.THIRD), spacer16, screenMdMin, spacer16));
var BodySection = withAnimationContext(styled(Type.p).attrs({
  variant: 'ballad'
}).withConfig({
  displayName: "TwoUpSegment__BodySection",
  componentId: "auxfm5-5"
})(["", ";"], fadeInAnimation(DELAYS.FOURTH)));
var SegmentTextLink = withAnimationContext(styled(ButtonTertiaryAsLink).withConfig({
  displayName: "TwoUpSegment__SegmentTextLink",
  componentId: "auxfm5-6"
})(["", ";padding-left:0px;text-align:left;color:", ";text-decoration:none;&:hover:not(:focus):not(:disabled){color:", ";}svg{padding-left:", ";padding-bottom:", ";vertical-align:middle;}"], fadeInAnimation(DELAYS.FIFTH), function (_ref) {
  var theme = _ref.theme;
  return theme.box.text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return hexToRgba(theme.box.text, 0.5);
}, spacer8, spacer4));
var TRACK_CAT = 'module-featuredContent2Up';
export var TwoUpSegment = function TwoUpSegment(_ref3) {
  var _ref3$twoUpSegment = _ref3.twoUpSegment,
      twoUpSegment = _ref3$twoUpSegment === void 0 ? {} : _ref3$twoUpSegment;
  return /*#__PURE__*/_jsxs(Segment, {
    children: [/*#__PURE__*/_jsxs(Left, {
      children: [/*#__PURE__*/_jsx(Headline, {
        children: twoUpSegment.segmentHeadline
      }), /*#__PURE__*/_jsx(BodySection, {
        children: twoUpSegment.segmentBody
      }), twoUpSegment.segmentLinkText && twoUpSegment.segmentLinkUrl && /*#__PURE__*/_jsxs(SegmentTextLink, {
        href: fixHref(twoUpSegment.segmentLinkUrl),
        track: [TRACK_CAT, "Link - ".concat(twoUpSegment.segmentLinkText)],
        children: [twoUpSegment.segmentLinkText, /*#__PURE__*/_jsx(IconArrowRight, {})]
      })]
    }), twoUpSegment.segmentImage && /*#__PURE__*/_jsx(RightContainer, {
      children: /*#__PURE__*/_jsx(Right, {
        children: /*#__PURE__*/_jsx(ContentfulImage, {
          asset: twoUpSegment.segmentImage
        })
      })
    })]
  });
};